import { useDataSubmit, useDataValue } from 'Simple/Data'

export function useOnClick(props) {
  let patient_id = useDataValue({
    context: 'patient',
    path: 'id',
    viewPath: props.viewPath,
  })
  let appointment_id = useDataValue({
    context: 'event',
    path: 'appointment.id',
    viewPath: props.viewPath,
  })

  let tx_location = useDataValue({
    context: 'event',
    path: 'appointment.tx.organization',
    viewPath: props.viewPath,
  })

  let patient_uuid = useDataValue({
    context: 'patient',
    path: '_id',
    viewPath: props.viewPath,
  })

  let appointment_uuid = useDataValue({
    context: 'event',
    path: 'appointment._id',
    viewPath: props.viewPath,
  })

  let submit = useDataSubmit({
    context: 'patient',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'showCalendar',
      coreParams: {
        patient_id,
        appointment_id,
        is_rescheduling: true,
      },
      sync: {
        patient_id: patient_uuid,
        appointment_id: appointment_uuid,
        location: tx_location,
      },
    })
  }
}
